// e-Belge Ayarları — Tenant'ın entegratör ayarları
// embedded=true ise: outer wrapper olmadan content render (SettingsPage içinde kullanılır)
// embedded=false ise: standalone sayfa
import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { Button, FormField, Modal } from '../components/ui';

export default function EDocumentSettingsPage({ embedded = false }) {
  const [settings, setSettings] = useState(null);
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);
  const [showCredsModal, setShowCredsModal] = useState(false);
  const [creds, setCreds] = useState({ secret_key: '', username: '', password: '', api_key: '' });
  const [testing, setTesting] = useState(false);
  const [testResult, setTestResult] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get('/e-documents/settings');
      if (r.data.success) {
        setSettings(r.data.data || { provider_id: r.data.providers[0]?.id || '', mode: 'own', is_test_mode: true });
        setProviders(r.data.providers || []);
      }
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const f = (k, v) => setSettings(p => ({ ...p, [k]: v }));

  const save = async () => {
    setSaving(true); setMsg(null);
    try {
      await api.post('/e-documents/settings', settings);
      setMsg({ type: 'success', text: 'Ayarlar kaydedildi' });
      await load();
    } catch (e) { setMsg({ type: 'error', text: e.response?.data?.message || 'Kayıt başarısız' }); }
    finally { setSaving(false); }
  };

  const testConnection = async () => {
    setTesting(true); setTestResult(null);
    try {
      const r = await api.post('/e-documents/settings/test-connection', creds);
      if (r.data.success) {
        setTestResult({ type: 'success', data: r.data.data });
        setSettings(p => ({
          ...p,
          api_key: creds.api_key,
          secret_key: creds.secret_key,
          username_encrypted: r.data.data.encryptedUsername,
          password_encrypted: r.data.data.encryptedPassword,
          vkn_tckn: p?.vkn_tckn || r.data.data.vkn,
          efatura_gb: p?.efatura_gb || r.data.data.efaturaGb,
          eirsaliye_gb: p?.eirsaliye_gb || r.data.data.eIrsaliyeGb,
        }));
      } else {
        setTestResult({ type: 'error', message: r.data.message });
      }
    } catch (e) {
      setTestResult({ type: 'error', message: e.response?.data?.message || e.message });
    } finally { setTesting(false); }
  };

  if (loading) return <div style={{ padding: embedded ? 0 : 24 }}>Yükleniyor...</div>;

  const inner = (
    <>
      {msg && (
        <div style={{
          padding: 10, borderRadius: 4, marginBottom: 12,
          background: msg.type === 'error' ? 'rgba(220,38,38,0.08)' : 'rgba(16,185,129,0.08)',
          color: msg.type === 'error' ? '#991b1b' : 'var(--success)',
        }}>{msg.text}</div>
      )}

      {/* Sağlayıcı + mod */}
      <section style={card}>
        <h3 style={cardTitle}>Sağlayıcı Seçimi</h3>
        <div className="form-grid">
          <FormField label="Entegratör">
            <select value={settings?.provider_id || ''} onChange={e => f('provider_id', e.target.value)}>
              {providers.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
          </FormField>
          <FormField label="Çalışma Modu">
            <select value={settings?.mode || 'own'} onChange={e => f('mode', e.target.value)}>
              <option value="own">Kendi Hesabım (kendi entegratör abonem)</option>
              <option value="master">hent Master Hesabı (alt mükellef)</option>
            </select>
          </FormField>
          <FormField label="Ortam">
            <select value={settings?.is_test_mode ? '1' : '0'} onChange={e => f('is_test_mode', e.target.value === '1')}>
              <option value="1">Test (Sandbox)</option>
              <option value="0">Canlı (Production)</option>
            </select>
          </FormField>
        </div>
      </section>

      {/* Mükellef bilgileri */}
      <section style={card}>
        <h3 style={cardTitle}>Mükellef Bilgileri</h3>
        <div className="form-grid">
          <FormField label="VKN / TCKN">
            <input value={settings?.vkn_tckn || ''} onChange={e => f('vkn_tckn', e.target.value)} placeholder="10 veya 11 hane" />
          </FormField>
          <FormField label="Vergi Dairesi">
            <input value={settings?.tax_office || ''} onChange={e => f('tax_office', e.target.value)} />
          </FormField>
          <FormField label="e-Fatura GB / Posta Kutusu URN">
            <input value={settings?.efatura_gb || ''} onChange={e => f('efatura_gb', e.target.value)} placeholder="urn:mail:..." />
          </FormField>
          <FormField label="e-İrsaliye GB / Posta Kutusu URN">
            <input value={settings?.eirsaliye_gb || ''} onChange={e => f('eirsaliye_gb', e.target.value)} placeholder="urn:mail:..." />
          </FormField>
          <FormField label="e-Fatura Mükellefiyim?">
            <select value={settings?.is_efatura_user ? '1' : '0'} onChange={e => f('is_efatura_user', e.target.value === '1')}>
              <option value="0">Hayır</option><option value="1">Evet</option>
            </select>
          </FormField>
          <FormField label="e-İrsaliye Mükellefiyim?">
            <select value={settings?.is_eirsaliye_user ? '1' : '0'} onChange={e => f('is_eirsaliye_user', e.target.value === '1')}>
              <option value="0">Hayır</option><option value="1">Evet</option>
            </select>
          </FormField>
          <FormField label="e-Arşiv Mükellefiyim?">
            <select value={settings?.is_earsiv_user ? '1' : '0'} onChange={e => f('is_earsiv_user', e.target.value === '1')}>
              <option value="0">Hayır</option><option value="1">Evet</option>
            </select>
          </FormField>
        </div>
      </section>

      {/* Bağlantı bilgileri */}
      <section style={card}>
        <h3 style={cardTitle}>Bağlantı Bilgileri</h3>
        <div style={{ marginBottom: 12, fontSize: 13, color: 'var(--text-secondary)' }}>
          ApiKey ve şifrelenmiş kullanıcı adı/şifre. Doğrudan giremezsiniz — <strong>"Bağlantıyı Test Et ve Kaydet"</strong> ile bir kez işlem yapın.
        </div>
        <div className="form-grid">
          <FormField label="API Key">
            <input value={settings?.api_key || ''} disabled placeholder="(boş — test edip kaydedince dolacak)" />
          </FormField>
          <FormField label="Secret Key">
            <input value={settings?.secret_key_encrypted ? '✓ Kayıtlı' : ''} disabled placeholder="(boş)" />
          </FormField>
          <FormField label="Şifrelenmiş Kullanıcı Adı">
            <input value={settings?.username_encrypted ? '✓ Kayıtlı' : ''} disabled placeholder="(boş)" />
          </FormField>
          <FormField label="Şifrelenmiş Şifre">
            <input value={settings?.password_encrypted ? '✓ Kayıtlı' : ''} disabled placeholder="(boş)" />
          </FormField>
        </div>
        <div style={{ marginTop: 12 }}>
          <Button size="sm" onClick={() => { setShowCredsModal(true); setTestResult(null); setCreds({ secret_key: '', username: '', password: '', api_key: settings?.api_key || '' }); }}>
            🔑 Bağlantıyı Test Et ve Kaydet
          </Button>
        </div>
      </section>

      {/* Test bağlantı modal */}
      {showCredsModal && (
        <Modal title="Hızlı Bilişim Bağlantı Testi" size="md" onClose={() => setShowCredsModal(false)}
               primaryAction={{ label: '🔌 Test Et', onClick: testConnection, loading: testing }}
               cancelAction={{ label: 'Vazgeç', onClick: () => setShowCredsModal(false) }}>
          <div style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 12 }}>
            Hızlı Bilişim'in size ilettiği bilgileri girin. Test başarılıysa şifrelenmiş hâlleri sistemde saklanır.
            Plain şifre asla DB'ye yazılmaz.
          </div>
          <FormField label="API Key" required><input value={creds.api_key} onChange={e => setCreds({ ...creds, api_key: e.target.value })} /></FormField>
          <FormField label="Secret Key" required><input type="password" value={creds.secret_key} onChange={e => setCreds({ ...creds, secret_key: e.target.value })} /></FormField>
          <FormField label="Kullanıcı Adı" required><input value={creds.username} onChange={e => setCreds({ ...creds, username: e.target.value })} /></FormField>
          <FormField label="Şifre" required><input type="password" value={creds.password} onChange={e => setCreds({ ...creds, password: e.target.value })} /></FormField>

          {testResult && (
            <div style={{
              marginTop: 12, padding: 12, borderRadius: 6,
              background: testResult.type === 'success' ? 'rgba(16,185,129,0.08)' : 'rgba(220,38,38,0.08)',
              color: testResult.type === 'success' ? 'var(--success)' : '#991b1b',
            }}>
              {testResult.type === 'success' ? (
                <div>
                  <strong>✓ Bağlantı başarılı!</strong>
                  <div style={{ marginTop: 8, fontSize: 13 }}>
                    Mükellef: <strong>{testResult.data.unvan}</strong><br/>
                    VKN: <strong>{testResult.data.vkn}</strong><br/>
                    e-Fatura GB: {testResult.data.efaturaGb || '-'}<br/>
                    Şifrelenmiş bilgiler hazır — modal'ı kapatın ve "Kaydet" tuşuna basın.
                  </div>
                </div>
              ) : (
                <div>
                  <strong>✗ Bağlantı başarısız</strong>
                  <div style={{ marginTop: 4, fontSize: 13 }}>{testResult.message}</div>
                </div>
              )}
            </div>
          )}
        </Modal>
      )}
    </>
  );

  // Embedded mod: outer wrapper olmadan, sadece içerik
  if (embedded) {
    return (
      <div>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
          <h2 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 600, flex: 1 }}>e-Belge Ayarları</h2>
          <Button size="sm" onClick={save} loading={saving}>Kaydet</Button>
        </div>
        {inner}
      </div>
    );
  }

  // Standalone: stocks-page wrapper
  return (
    <div className="stocks-page">
      <div className="stocks-topbar">
        <div className="stocks-topbar-left">
          <h2>e-Belge Ayarları</h2>
        </div>
        <div className="stocks-topbar-right">
          <Button size="sm" onClick={save} loading={saving}>Kaydet</Button>
        </div>
      </div>
      <div style={{ flex: 1, overflowY: 'auto', padding: 16 }}>
        {inner}
      </div>
    </div>
  );
}

const card = {
  background: 'var(--bg-primary, #fff)',
  border: '1px solid var(--border-color, #e5e5e5)',
  borderRadius: 8, padding: '16px 18px', marginBottom: 16,
};
const cardTitle = { margin: '0 0 12px', fontSize: 14, fontWeight: 600, color: 'var(--text-secondary, #444)' };
